import React, { useEffect, useRef, useState } from 'react';
import styles from './DataMapDrawer.module.scss';
import ProductFlowMap from 'views/CreateProductFlow/ProductOverview/ProductFlowMap';
import { ProductRawMaterial } from 'models/ProductRawMaterial/productRawMaterial.model';
import { ProductRawMaterialTransportations } from 'models/ProductRawMaterialTransportations/productRawMaterialTransportations.model';
import { useLocation } from 'react-router-dom';
import { isActiveTab } from './DataMapDrawerHelper';
import { DataMappingProps } from 'enums/CreateProductStageNavigationBarEnums';
import { ProductMapRoots } from 'enums/ProductFlowMapEnums';
import { EmissionDataContext } from 'context/EmissionDataContext';
import { FlowContainerConstants } from 'views/FlowContainer/FlowContainerConstants';
import { ProcessingFacilityEmissionData } from 'models/ProcessingFacilityEmissionData/ProcessingFacilityEmissionData.model';

export interface MappingDiagramCanvasProps {
  stage1Data: ProductRawMaterial[];
  stage2Data: ProductRawMaterialTransportations[];
  stage3Data: ProcessingFacilityEmissionData | null;
}
const MappingDiagramCanvas: React.FC<MappingDiagramCanvasProps> = ({
  stage1Data,
  stage2Data,
  stage3Data,
}: MappingDiagramCanvasProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    setStage1Data,
    setStage2Data,
    setStage3Data,
    setStage1Total,
    setStage2Total,
    setStage3Total,
  } = React.useContext(EmissionDataContext);
  const {
    STAGE_1_TOTAL_EMISSION,
    STAGE_2_TOTAL_EMISSION,
    STAGE_3_TOTAL_EMISSION,
  } = FlowContainerConstants;
  const location = useLocation();

  const getMapProps = () =>
    isActiveTab(DataMappingProps.TRANSPORTATION, location) && {
      stage1Data,
    }
      ? { stage1Emissions: stage1Data }
      : isActiveTab(DataMappingProps.PROCESSING_FACILITY, location) &&
        stage1Data &&
        stage2Data
      ? { stage1Emissions: stage1Data, stage2Emissions: stage2Data }
      : isActiveTab(DataMappingProps.PRODUCT_DISTRIBUTION, location) &&
        stage1Data &&
        stage2Data &&
        stage3Data
      ? {
          stage1Emissions: stage1Data,
          stage2Emissions: stage2Data,
          stage3Emissions: stage3Data,
        }
      : {};
  const [productMapProps, setProductMapProps] = useState(getMapProps());

  useEffect(() => {
    setProductMapProps(getMapProps());
  }, [stage1Data, stage2Data, stage3Data]);

  useEffect(() => {
    if (isActiveTab(DataMappingProps.RAW_MATERIAL, location)) {
      localStorage.setItem(DataMappingProps.STAGE_1, JSON.stringify([]));
      setStage1Data([]);
      setStage1Total(0);
      localStorage.setItem(STAGE_1_TOTAL_EMISSION, JSON.stringify(0));
      localStorage.setItem(DataMappingProps.STAGE_2, JSON.stringify([]));
      setStage2Data([]);
      setStage2Total(0);
      localStorage.setItem(DataMappingProps.STAGE_3, JSON.stringify([]));
      setStage3Data({});
      setStage3Total(0);
    }
    if (isActiveTab(DataMappingProps.TRANSPORTATION, location)) {
      localStorage.setItem(DataMappingProps.STAGE_2, JSON.stringify([]));
      setStage2Data([]);
      setStage2Total(0);
      localStorage.setItem(STAGE_2_TOTAL_EMISSION, JSON.stringify(0));
      localStorage.setItem(DataMappingProps.STAGE_3, JSON.stringify([]));
      setStage3Data({});
      setStage3Total(0);
      localStorage.setItem(STAGE_3_TOTAL_EMISSION, JSON.stringify(0));
    }
  }, []);

  return (
    <div
      className={styles.topContainer}
      id={ProductMapRoots.PRODUCT_CREATION_FLOW_ROOT}>
      <div className={styles.mappingContainer} ref={containerRef}>
        {productMapProps && (
          <ProductFlowMap
            {...{
              ...productMapProps,
              rootId: ProductMapRoots.PRODUCT_CREATION_FLOW_ROOT,
              hideColor: true,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default MappingDiagramCanvas;
